import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable Confirmation Modal Component
 * Extracted from mes-dossiers.js
 */
export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmation',
  message,
  secondaryMessage,
  confirmText = 'Continuer',
  cancelText = 'Annuler',
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h2 className="text-xl font-bold mb-4">{title}</h2>
        {message && <p className="text-gray-600 mb-4">{message}</p>}
        {secondaryMessage && <p className="text-gray-600 mb-6">{secondaryMessage}</p>}

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="text-base font-semibold text-white flex items-center justify-center px-4 py-2 rounded-md bg-primary hover:bg-primary/90 transition-colors"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  secondaryMessage: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
};
